import api from './api';
import jwtDecode from 'jwt-decode';

export const authService = {
  async login(credentials) {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },
  
  async logout() {
    return await api.post('/auth/logout');
  },
  
  async getCurrentUser() {
    const response = await api.get('/auth/me');
    return response.data;
  },
  
  async forgotPassword(email) {
    return await api.post('/auth/forgot-password', { email });
  },
  
  async resetPassword(token, newPassword) {
    return await api.post('/auth/reset-password', { token, newPassword });
  },
  
  getTokenInfo() {
    const token = localStorage.getItem('token');
    if (!token) return null;
    
    try {
      return jwtDecode(token);
    } catch (error) {
      console.error('Invalid token:', error);
      return null;
    }
  },
  
  isTokenExpired() {
    const tokenInfo = this.getTokenInfo();
    if (!tokenInfo) return true;
    
    // Check if token is expired (exp is in seconds, Date.now() is in milliseconds)
    return tokenInfo.exp * 1000 < Date.now();
  }
};
